import { SvgIcon, SvgIconProps } from 'ui/icons/SvgIcon';

export const Overview = ({ height = 128, width = 128, ...props }: SvgIconProps) => (
  <SvgIcon height={height} width={width} viewBox="0 0 128 128" {...props}>
    <g clipPath="url(#clip0)">
      <path
        d="M115.84 71.8085C115.839 64.1681 114.129 56.6247 110.833 49.7314C107.538 42.8382 102.742 36.7697 96.7966 31.9711C90.851 27.1725 83.907 23.7654 76.4734 21.9995C69.0399 20.2337 61.3054 20.1539 53.837 21.766C46.3686 23.378 39.3557 26.6412 33.3125 31.3161C27.2692 35.991 22.3488 41.9591 18.9121 48.7829C15.4753 55.6068 13.6094 63.1132 13.451 70.752C13.2926 78.3907 14.8459 85.9681 17.9968 92.9285H111.283C114.293 86.2946 115.847 79.0931 115.84 71.8085Z"
        fill="#F5F4F4"
      />
      <path
        d="M14.08 92.9277H113.92"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M8.32 92.9277H11.52" stroke="#6A266D" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M116.48 92.9277H119.68"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M95.9104 104.96C95.9104 106.24 81.8304 107.392 64.3328 107.392C46.8352 107.392 32.768 106.304 32.768 104.96C32.768 103.616 46.848 102.528 64.3328 102.528C81.8176 102.528 95.9104 103.68 95.9104 104.96Z"
        fill="#F5F4F4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M72.5833 103.5H56.75C59.2221 99.6663 60.8419 95.3466 61.5 90.833H67.8333C68.4986 95.3448 70.1179 99.6629 72.5833 103.5Z"
        fill="#B56DC6"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M52 103.5H77.3333" stroke="#6A266D" strokeLinecap="round" strokeLinejoin="round" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M75.75 90.8333H37.75C36.0876 90.6403 34.7764 89.3291 34.5833 87.6667V49.6667C34.7764 48.0043 36.0876 46.6931 37.75 46.5H91.5833C93.2457 46.6931 94.5569 48.0043 94.75 49.6667V67.0833"
        fill="#E6FBFF"
      />
      <path
        d="M75.75 90.8333H37.75C36.0876 90.6403 34.7764 89.3291 34.5833 87.6667V49.6667C34.7764 48.0043 36.0876 46.6931 37.75 46.5H91.5833C93.2457 46.6931 94.5569 48.0043 94.75 49.6667V67.0833V90.8333H75.75Z"
        fill="#E6FBFF"
      />
      <path
        d="M75.75 90.8333H37.75C36.0876 90.6403 34.7764 89.3291 34.5833 87.6667V49.6667C34.7764 48.0043 36.0876 46.6931 37.75 46.5H91.5833C93.2457 46.6931 94.5569 48.0043 94.75 49.6667V67.0833V90.8333H75.75Z"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M40.9166 78.167H75.75"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M45.6667 65.5H48.8333C49.7078 65.5 50.4167 66.2089 50.4167 67.0833V78.1667H44.0833V67.0833C44.0833 66.2089 44.7922 65.5 45.6667 65.5Z"
        fill="#FDF5FF"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M71 71.833H74.1666C75.0411 71.833 75.75 72.5419 75.75 73.4163V78.1663H69.4166V73.4163C69.4166 72.5419 70.1255 71.833 71 71.833Z"
        fill="#FEE5E9"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M58.3333 56H61.5C62.3744 56 63.0833 56.7089 63.0833 57.5833V78.1667H56.75V57.5833C56.75 56.7089 57.4589 56 58.3333 56Z"
        fill="#E6FFF7"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path fillRule="evenodd" clipRule="evenodd" d="M34.5833 84.5H75.75H34.5833Z" fill="#B56DC6" />
      <path
        d="M34.5833 84.5H75.75H94.75V89.25L93.1667 90.8333H37.75C35.375 90.8333 34.5833 90.8333 34.5833 88.4583V84.5Z"
        fill="#B56DC6"
      />
      <path
        d="M34.5833 84.5H75.75H94.75V89.25L93.1667 90.8333M34.5833 84.5C34.5833 84.5 34.5833 86.0833 34.5833 88.4583M34.5833 84.5V88.4583M93.1667 90.8333C93.1667 90.8333 40.125 90.8333 37.75 90.8333M93.1667 90.8333H37.75M37.75 90.8333C35.375 90.8333 34.5833 90.8333 34.5833 88.4583"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M91.5833 103.5C86.447 103.5 82.0833 100.72 82.0833 95.5837V87.667H101.083V95.5837C100.95 97.9236 99.8519 100.103 98.0514 101.604C96.2509 103.104 93.909 103.791 91.5833 103.5Z"
        fill="#FDF5FF"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M88.9265 77.375C86.6085 79.693 91.2255 80.4815 88.9581 82.7583"
        stroke="#CCC8CA"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M97.7188 78.5625C95.9375 79.75 98.9063 80.9375 97.3767 82.7188"
        stroke="#CCC8CA"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M93.2298 73.3301C89.1955 77.3644 97.2357 78.7387 93.2868 82.6876"
        stroke="#CCC8CA"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M101.083 89.25H102.667C105.29 89.25 107.417 91.3766 107.417 94C107.417 96.6234 105.29 98.75 102.667 98.75H100.279"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="128" height="128" fill="white" />
      </clipPath>
    </defs>
  </SvgIcon>
);
